import { cn } from '@lair-finance/util'
import { Button } from '@/shared/ui/Button'
import { useDisconnect } from '@lair-finance/wagmi'
import { AssetIcon } from '@/shared/ui/Asset'
import { useResponsive } from '@/features/responsive/hooks/useResponsive.ts'

export const DisconnectButton = ({ className }: { className?: string }) => {
  const isTablet = useResponsive('tablet')
  const { disconnect } = useDisconnect()

  return (
    <Button
      size={isTablet ? 'lg' : 'md'}
      color={'transparent'}
      icon={<AssetIcon filename={'disconnect.png'} size={24} />}
      className={cn('border border-greyscale-500 text-palette-red ', className)}
      hoverable={false}
      onClick={() => disconnect()}
    >
      Disconnect
    </Button>
  )
}
